import React from 'react';
import '../../App.css';
import AccountReportForm from '../SubGroupReport';

function SubgroupReportPage({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("account-report")){
    return;}
  return (
    <div className="page-mr">
      <AccountReportForm sessionObject={sessionObject}/>
    </div>
  );
}

export default SubgroupReportPage;